module.exports = __webpack_public_path__ + "static/featuresSlider6.0e5417e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thehouse/featuresSlider6.jpg
// module id = 423
// module chunks = 233451654573184